import { type User } from "@entities";
import { Stack } from "@mui/material";
import { ImageLoaded } from "clients/admin/src/desktop/components/image-loaded/ImageLoaded";
import randomColor from "randomcolor";
import { useMemo, type FC } from "react";
import { CustomCell } from "./types";

const UserNameAndPhoto: FC<{ user?: User; strongName?: string; }> = ({ user, strongName }) => {
  if (!user) return null;
  const { profileImageId, name, id } = user;
  return (
    <Stack flexDirection="row" alignItems="center" gap="0.8rem">
      <ImageLoaded
        imageId={profileImageId}
        alt={name}
        styleObject={{
          width: "2rem",
          height: "2rem",
          borderRadius: "0.8rem",
          backgroundColor: randomColor({
            luminosity: "light",
            seed: id,
          }),
        }}
      />
      <span title={name}>{strongName || name}</span>
    </Stack>
  );
};

export default UserNameAndPhoto;
